import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import contactServices from './contact_services';

export const UserContactSubmission = createAsyncThunk(
  'user_contact/submit_contact',
  async (payload, thunkAPI) => {
    try {
      let response = await contactServices.contactSubmission(payload);
      toast.success('Message sent successfully');
      return response;
    } catch (error) {
      toast.error(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
